import React from 'react';
import { Select } from 'antd';
import { DayChip } from '../style/schedule.style';

const DAYS_LIST = [
    { key: 'mon', label: 'Monday' },
    { key: 'tue', label: 'Tuesday' },
    { key: 'wed', label: 'Wednesday' },
    { key: 'thu', label: 'Thursday' },
    { key: 'fri', label: 'Friday' },
    { key: 'sat', label: 'Saturday' },
    { key: 'sun', label: 'Sunday' },
];

export const WorkingDaysChipsInput = ({ value = [], onChange }) => {
    const selectedDays = Array.isArray(value) ? value : [];

    const handleToggleDay = (dayKey) => {
        if (selectedDays.includes(dayKey)) {
            onChange(selectedDays.filter((d) => d !== dayKey));
        } else {
            onChange([...selectedDays, dayKey]);
        }
    };

    const handleSelectDay = (dayKey) => {
        if (dayKey && !selectedDays.includes(dayKey)) {
            onChange([...selectedDays, dayKey]);
        }
    };

    const unselectedOptions = DAYS_LIST
        .filter((d) => !selectedDays.includes(d.key))
        .map((d) => ({ value: d.key, label: d.label }));

    return (
        <div>
            <Select
                placeholder={unselectedOptions.length === 0 ? 'All days selected' : 'Search & select working day...'}
                options={unselectedOptions}
                onChange={handleSelectDay}
                value={null}
                disabled={unselectedOptions.length === 0}
                showSearch
                optionFilterProp="label"
                style={{ width: '100%', marginBottom: 10 }}
            />
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                {DAYS_LIST.map((day) => {
                    const isSelected = selectedDays.includes(day.key);
                    return (
                        <DayChip
                            key={day.key}
                            $isSelected={isSelected}
                            onClick={() => handleToggleDay(day.key)}
                        >
                            <span>{isSelected ? '✓' : '+'}</span>
                            <span>{day.label}</span>
                        </DayChip>
                    );
                })}
            </div>
        </div>
    );
};
export default WorkingDaysChipsInput;
